// landing subscribe

$(function () {
    if ($('#landing-videochiamata').length > 0) {
        $('.header-main').addClass('hide');
        $('.body-container').attr('style', 'margin-top:0px!important');
        $('.margin-section').attr('style', 'margin-top:0px!important');
    }

});